import type {
  RouteLocation,
  RouteLocationNormalized,
  RouteRecordRaw,
} from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import {
  PATH_DTWINS,
  PATH_DTWINS_ID,
  PATH_DTWINS_ID_ADDITIONAL_METADATA,
  PATH_DTWINS_ID_CERTIFICATE,
  PATH_DTWINS_ID_CONFIGURATION,
  PATH_DTWINS_ID_DATA_VISUALISATION,
  PATH_DTWINS_ID_DESCRIPTION,
  PATH_DTWINS_ID_FIRMWARE,
  PATH_DTWINS_ID_LOGS,
} from "~/modules/dtwin/constants";
import DtwinPage from "~/modules/dtwin/views/DtwinPage.vue";
import DtwinsPage from "~/modules/dtwin/views/DtwinsPage.vue";
import { router } from "~/plugins/router";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_DTWINS,
    component: DtwinsPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    // The dtwin page does not exist by itself, it is a wrapper for the dtwin tabs. The navigation to this page (via the
    // left panel or the URL) must redirect to the description tab.
    path: PATH_DTWINS_ID,
    redirect: (to: RouteLocation) =>
      router.resolve({
        name: PATH_DTWINS_ID_DESCRIPTION,
        params: { id: to.params.id },
      }),
  },
  {
    path: PATH_DTWINS_ID_DESCRIPTION,
    component: DtwinPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_CERTIFICATE,
    component: DtwinPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_FIRMWARE,
    component: DtwinPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_CONFIGURATION,
    component: DtwinPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_DATA_VISUALISATION,
    component: DtwinPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_ADDITIONAL_METADATA,
    component: DtwinPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
  {
    path: PATH_DTWINS_ID_LOGS,
    component: DtwinPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.DTWIN,
    },
  },
];

export default routes;
